import {
  Box,
  Button,
  Col,
  Icon,
  Row,
  Text,
} from '@cubeyou-team/hx-react-components';
import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showEditAudienceModal } from 'src/actions/CreateAudienceModalActions';
import { MODAL_TYPES } from 'src/components/RepositoryItemActions/constants';
import { useAudienceActivationContext } from 'src/modules/audience-activation/providers/AudienceActivationProvider';
import translations from 'src/lang';
import { sendEvent } from 'src/actions/EventsActions';

const lang = 'en-US';

interface FormHeaderProps {
  modalType: keyof typeof MODAL_TYPES;
}

export const FormHeader: FC<FormHeaderProps> = ({ modalType }) => {
  const dispatch = useDispatch();
  const { repositoryItem, closeModal } = useAudienceActivationContext();

  const handleOpenAudience = useCallback(() => {
    dispatch(showEditAudienceModal({ audience: repositoryItem }));
    dispatch(sendEvent('Workspace'));
    closeModal();
  }, [repositoryItem, dispatch, closeModal]);

  if (modalType === MODAL_TYPES.OPEN_CAMPAIGN) {
    return (
      <>
        <Box pB="small">
          <Button type="submit" size="small" onClick={handleOpenAudience}>
            {translations[lang].MODALS.AUDIENCE_ACTIVATION.BUTTON_OPEN_AUDIENCE}
          </Button>
        </Box>
        <Box pT="small">
          <Row valign="middle" gutter="small">
            <Col span="auto">
              <Icon size="medium" icon="calendar" />
            </Col>
            <Col span="auto">
              <Text variant="dark" size="medium">
                {
                  translations[lang].MODALS.AUDIENCE_ACTIVATION
                    .ACTIVATION_DATE_LABEL
                }
              </Text>
            </Col>
          </Row>
        </Box>
      </>
    );
  }

  return (
    <Row>
      <Text variant="dark_lighter" size="xbody" className="paragraph">
        {translations[lang].MODALS.AUDIENCE_ACTIVATION.CONTENT_DESCRIPTION}
      </Text>
    </Row>
  );
};
